import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { HeaderStyle } from "../Common/styles/header";
import SponsorsList from "./SponsorsList";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";
import { dataTablePageShell } from "../../utils/dataTableShell";

const Sponsors = () => {
  const { platformPermissions } = useAppSelector((state) => state.user);
  const [showModal, setShowModal] = useState(false);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions]
  );

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Clients/Sponsors
        </Typography>

        {canEdit && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              New Client/Sponsor
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2.5, ...dataTablePageShell("calc(100% - 72px)") }}>
        <SponsorsList
          canEdit={canEdit}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      </Box>
    </>
  );
};

export default Sponsors;
